// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","press":"_2HjvmtYJK_Qztm7w1SlWBS"};